import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

export const StyledJobStatusLabel = styled.span`
    ${setFontVariant("caption")};
    color: ${colorsPalettes.carbon[300]};
`;

export const StyledJobStatusValue = styled.span`
    ${setFontVariant("caption")};
    color: ${colorsPalettes.carbon[400]};
`;

export const StyledJobStatusIcon = styled.span<{ $color: string }>`
    color: ${({ $color }) => $color};
    display: flex;
    align-items: center;
`;
